var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"underline cursor-pointer",on:{"click":function($event){return _vm.$router.push(`/admin/tags/${_vm.data.key}`)}}},[_vm._v(_vm._s(_vm.data.key))])
}
var staticRenderFns = []

export { render, staticRenderFns }